import {AppPage} from "common/Layout";
import {AppText} from "shared/UI/UIKit/Text";
import {Test} from "pages/Test/components/Test";
import {AppFlex} from "shared/UI/UIKit/Flex";
import type {TestPage as TestPageType} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import {PageType} from "../../config/types";
import styles from "./styles.module.scss";

export const TestPage = () => {
  const testPage = GLOBAL_CONFIG.pages.find(page => page.type === PageType.TEST) as TestPageType;

  if (!testPage) {
    return null;
  }

  return (
    <AppPage contentClassName={styles.content}
             pageTitle="Контроль" documentTitle="Контроль">
      <AppFlex unit="35">
        <AppText className={styles.title} size={24}>Контроль</AppText>
        <Test questions={testPage.questions}/>
      </AppFlex>
    </AppPage>
  );
};

